import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AccessRole, LocalService } from 'lib-base';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { AuthenticatedLayoutComponent } from '../../layouts/authenticated-layout/authenticated-layout.component';
import { AppMenuitemComponent } from '../app-menuitem/app-menuitem.component';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [
    CommonModule, RouterModule,
    AppMenuitemComponent
  ],
  templateUrl: './app-menu.component.html',
  styleUrl: './app-menu.component.scss'
})
export class AppMenuComponent implements OnInit {

  model !: any[];

  constructor(public appMain: AuthenticatedLayoutComponent, private readonly _ls: LocalService, private readonly _translate: TranslateService) { }

  ngOnInit() {
    this.translate();
  }

  private async translate(): Promise<void> {
    const translations = await firstValueFrom(forkJoin({
      configuracion: this._translate.get('app-menu.configuracion'),
      seguridad: this._translate.get('app-menu.seguridad'),
      usuarios: this._translate.get('app-menu.usuarios'),
      cargos: this._translate.get('app-menu.cargos'),
      dependencias: this._translate.get('app-menu.dependencias'),
      formulario: this._translate.get('app-menu.formulario'),
      formularios: this._translate.get('app-menu.formularios'),
      nuevoFormulario: this._translate.get('app-menu.nuevo-formulario'),
      tramiteWizard: this._translate.get('app-menu.tramite-wizard'),
      dashboards: this._translate.get('app-menu.dashboards'),
      historicoTramites: this._translate.get('app-menu.historico-tramites'),
      generalDashboard: this._translate.get('app-menu.dashboard-general'),
      generalDashboardSisben: this._translate.get('app-menu.dashboard-general-sisben'),
      balanceTramitesPorDependencia: this._translate.get('app-menu.balance-tramites-por-dependencia'),
      balanceTramitesSisben: this._translate.get('app-menu.balance-tramites-sisben'),
      misTramites: this._translate.get('app-menu.misTramites'),
      panelDeTrámites: this._translate.get('msg.panelDeTrámites'),
      gestionTramites: this._translate.get('msg.gestionTramites'),
      pqrsd: this._translate.get('msg.panelDePQRSD'),
      misPQRSD: this._translate.get('msg.misPQRSD'),
      gestionPQRSD: this._translate.get('msg.gestionPQRSD'),
      firmaElectronica: this._translate.get('common.firmaElectronica'),
      datasetsDinamicos: this._translate.get('app-menu.datasets-dinamicos'),
      asignacionManual: this._translate.get('common.asignacionManual'),
      firmaElectronicaSolicitudes: this._translate.get('msg.firmaElectronicaRevocaciones'),
      chatAssistant: this._translate.get('app-menu.chat-asistente-ia'),
      chatConsultas: this._translate.get('app-menu.chat-consultas'),
      correoPlantilla: this._translate.get('app-menu.correo-plantilla'),
      controlTiempo: this._translate.get('app-menu.control-tiempo'),
      sisben: this._translate.get('common.sisben'),
      gestionSisben: this._translate.get('app-menu.gestion-sisben'),
    }));

    this.model = [];

    // Mis Trámites
    if (this.hasAccess(AccessRole.GESTION_TRAMITE)) {
      this.model.push({
        label: translations.misTramites,
        icon: 'pi pi-home',
        routerLink: ['/configuracion/landing'],
        visible: { hasAccess: true }
      });
    }

    if (this.hasAccess(AccessRole.ADMIN_TRAM)) {
      this.model.push({
        label: translations.gestionTramites,
        icon: 'pi pi-warehouse',
        routerLink: ['/configuracion/gestion-tramites'],
        visible: { hasAccess: true }
      });
    }

    if (this.hasAccess(AccessRole.GESTION_PQRSD)) {
      this.model.push({
        label: translations.misPQRSD,
        icon: 'pi pi-home',
        routerLink: ['/configuracion/mis-pqrsd'],
        visible: { hasAccess: true }
      });
    }

    if (this.hasAccess(AccessRole.ADMIN_PQRSD)) {
      this.model.push({
        label: translations.gestionPQRSD,
        icon: 'pi pi-warehouse',
        routerLink: ['/configuracion/gestion-pqrsd'],
        visible: { hasAccess: true }
      });
    }

    if (this.hasAccess(AccessRole.ASIGNACION_MANUAL)) {
      this.model.push({
        label: translations.asignacionManual,
        icon: 'pi pi-address-book',
        routerLink: ['/configuracion/asignacion-manual'],
        visible: { hasAccess: true }
      });
    }

    if (this.hasAccess(AccessRole.GESTION_FIRMA_ELECTRONICA)) {
      this.model.push({
        label: translations.firmaElectronicaSolicitudes,
        icon: 'pi pi-receipt',
        routerLink: ['/configuracion/firma-electronica/revocaciones'],
        visible: { hasAccess: true }
      });
    }

    if (this.hasAccess(AccessRole.SISBEN)) {
      this.model.push({
        label: translations.gestionSisben,
        icon: 'pi pi-pencil',
        routerLink: ['/sisben/gestion'],
        visible: { hasAccess: true }
      });
    }

    if (this.hasAccess(AccessRole.SISBEN)) {
      this.model.push({
        label: translations.sisben,
        icon: 'pi pi-desktop',
        routerLink: ['/sisben/consulta'],
        visible: { hasAccess: true }
      });
    }

    this.model.push({
      label: translations.chatAssistant,
        icon: 'pi pi-comments',
      routerLink: ['/configuracion/chat-assistant'],
      visible: { hasAccess: true }
    })

    //#region Configuración
    let configItems: any[] = [];

    if (this.hasAccess(AccessRole.ADMIN_TRAM)) {
      configItems.push({ label: translations.panelDeTrámites, icon: 'pi pi-briefcase', routerLink: ['/configuracion/admin-tramites'] });
      configItems.push({ label: translations.tramiteWizard, icon: 'pi pi-wrench', routerLink: ['/configuracion/tramite-wizard'] });
      configItems.push({ label: translations.datasetsDinamicos, icon: 'pi pi-table', routerLink: ['/configuracion/datasets-dinamicos'] });
    }

    if (this.hasAccess(AccessRole.ADMIN_PQRSD)) {
      configItems.push({ label: translations.pqrsd, icon: 'pi pi-building', routerLink: ['/configuracion/admin-pqrsd'] });
    }
    if (this.hasAccess(AccessRole.CHAT_CLIENT_DEV)) {
      configItems.push({
        label: translations.chatConsultas,
        icon: 'pi pi-inbox',
        routerLink: ['/configuracion/chat-consultas'],
        visible: { hasAccess: true },
      });
    }
    configItems.push({
      label: translations.correoPlantilla, icon: 'pi pi-envelope',
      routerLink: ['/configuracion/plantilla-correo'], visible: { hasAccess: true },
    });
    configItems.push({
      label: translations.controlTiempo, icon: 'pi pi-hourglass',
      routerLink: ['/configuracion/control-tiempo'], visible: { hasAccess: true },
    });

    if (this.hasAccess(AccessRole.ADMIN_FORM)) {
      configItems.push({
        label: translations.formularios,
        icon: 'pi pi-file',
        routerLink: ['/configuracion/formulario/formularios'],
      });
    }

    if (this.hasAccess(AccessRole.ADMIN_TRAM) || this.hasAccess(AccessRole.ADMIN_PQRSD)) {
      this.model.push({
        label: translations.configuracion,
        icon: 'pi pi-cog',
        routerLink: ['/configuracion'],
        visible: { hasAccess: true },
        items: configItems
      });
    }
    //#endregion Configuración


    // Seguridad
    if (this.hasAccess(AccessRole.ADMIN_SEC)) {
      this.model.push({
        label: translations.seguridad,
        icon: 'pi pi-lock',
        routerLink: ['/seguridad'],
        visible: { hasAccess: true },
        items: [
          { label: translations.usuarios, icon: 'pi pi-user', routerLink: ['/seguridad/admin-usuario'] },
          { label: translations.cargos, icon: 'pi pi-key', routerLink: ['/seguridad/admin-cargos'] },
          { label: translations.dependencias, icon: 'pi pi-building', routerLink: ['/seguridad/admin-dependencias'] },
          { label: translations.firmaElectronica, icon: 'pi pi-users', routerLink: ['/seguridad/portal-usuario'] },
        ]
      });
    }



    const dashboardItems: any[] = [];
    // Dashboards
    if (this.hasAccess(AccessRole.ADMIN_DASHBOARD)) {
      dashboardItems.push(
        {label: translations.generalDashboard, icon: 'pi pi-objects-column', routerLink: ['/dashboard/general']},
        {
          label: translations.historicoTramites,
          icon: 'pi pi-chart-line',
          routerLink: ['/dashboard/historico-tramites']
        },
        {
          label: translations.balanceTramitesPorDependencia,
          icon: 'pi pi-chart-bar',
          routerLink: ['/dashboard/balance-tramites-por-dependencia']
        },
        {
          label: translations.balanceTramitesPorDependencia,
          icon: 'pi pi-chart-pie',
          routerLink: ['/dashboard/tramites-por-dependencia']
        },
      );
    }
    // Dashboards SISBEN
    if (this.hasAccess(AccessRole.SISBEN)) {
      dashboardItems.push(
        {
          label: translations.generalDashboardSisben,
          icon: 'pi pi-objects-column',
          routerLink: ['/dashboard/general-sisben']
        },        
        {
          label: translations.balanceTramitesSisben,
          icon: 'pi pi-chart-pie',
          routerLink: ['/dashboard/tramites-sisben']
        })
    }

    if (this.hasAccess(AccessRole.ADMIN_DASHBOARD) || this.hasAccess(AccessRole.SISBEN)) {
      this.model.push({
        label: translations.dashboards,
        icon: 'pi pi-desktop',
        routerLink: ['/dashboard'],
        visible: {hasAccess: true},
        items: dashboardItems,
      });
    }
  }

  onMenuClick() {
    this.appMain.menuClick = true;
  }

  hasAccess(role: AccessRole): boolean {
    return this._ls.hasRole(role);
  }
}
